import { MAX_NAME_LENGTH } from './constants';

/** Trim and collapse internal whitespace. Applied before storing any name. */
export function normalizeName(raw: string): string {
  return raw.replace(/\s+/g, ' ').trim().slice(0, MAX_NAME_LENGTH);
}

/** Names are unique within a room, compared case-insensitively. */
export function nameKey(name: string): string {
  return normalizeName(name).toLocaleLowerCase('ro-RO');
}

/**
 * Up to two letters for the placeholder avatar.
 * "Andrei Popescu" -> "AP"; "Andrei" -> "AN"; "A" -> "A".
 */
export function deriveInitials(name: string): string {
  const words = normalizeName(name).split(' ').filter(Boolean);
  if (words.length === 0) return '?';
  if (words.length === 1) {
    return words[0]!.slice(0, 2).toLocaleUpperCase('ro-RO');
  }
  const first = words[0]![0]!;
  const last = words[words.length - 1]![0]!;
  return (first + last).toLocaleUpperCase('ro-RO');
}
